export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/appsumo-select-bg-green.e092d414.svg","height":25,"width":47};